import { Component, OnInit } from '@angular/core';
import { LinkComponent, GenericLinkComponent, IconComponent } from '@spartacus/storefront';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-efa-link',
    templateUrl: './efa-link.component.html',
    imports: [GenericLinkComponent, IconComponent, AsyncPipe]
})
export class EfaLinkComponent extends LinkComponent {
}
